import { render, staticRenderFns } from "./SettingsProfile.vue?vue&type=template&id=45de117c&scoped=true&"
import script from "./SettingsProfile.vue?vue&type=script&lang=js&"
export * from "./SettingsProfile.vue?vue&type=script&lang=js&"
import style0 from "./SettingsProfile.vue?vue&type=style&index=0&id=45de117c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45de117c",
  null
  
)

export default component.exports